export default __webpack_public_path__ + "static/webinar-desktop-00e6256e9afed17bee8b975183662198.png";